export function isPerfDebugEnabled() {
  try {
    return typeof window !== 'undefined' && window.localStorage.getItem('PERF_DEBUG') === '1';
  } catch (_) {
    return false;
  }
}

export function perfNow() {
  try {
    if (typeof performance !== 'undefined' && typeof performance.now === 'function') {
      return performance.now();
    }
  } catch (_) {}
  return Date.now();
}

export function logPerf(label, startedAt, meta = undefined) {
  if (!isPerfDebugEnabled()) return;
  const elapsedMs = Math.round(perfNow() - startedAt);
  if (meta !== undefined) {
    console.info(`[PERF] ${label}: ${elapsedMs}ms`, meta);
    return;
  }
  console.info(`[PERF] ${label}: ${elapsedMs}ms`);
}

